import { GetterTree } from "vuex";
import {
  GETTER_CURRENT_USER_MEDIA_LIST,
  GETTER_CURRENT_POST_INFO,
  GETTER_ONE_USER_MEDIA,
  GETTER_CURRENT_POST_ID
} from "@/store/constants/ins_media_types";
import {
  OneUserMediaInfoList,
  InsUserMediaList
} from "../modules/ins_media_module";
const Getters: GetterTree<any, any> = {
  [GETTER_CURRENT_USER_MEDIA_LIST](
    state: InsUserMediaList,
    getters: any,
    rootState: any
  ) {
    return getters[GETTER_ONE_USER_MEDIA](
      rootState.index_module.current_user_id
    );
  },
  [GETTER_CURRENT_POST_INFO](
    state: InsUserMediaList,
    getters: any,
    rootState: any
  ) {
    const ins_media_list_info = getters[GETTER_CURRENT_USER_MEDIA_LIST];
    if (ins_media_list_info) {
      const { ins_media_list } = ins_media_list_info;

      if (ins_media_list) {
        const findIndex = ins_media_list.findIndex((media: any) => {
          return media.id === state.current_post_id;
        });

        if (findIndex > -1) {
          return ins_media_list[findIndex];
        }
      }
    }
    return null;
  },
  [GETTER_CURRENT_POST_ID](
    state: InsUserMediaList,
    getters: any,
    rootState: any
  ) {
    return state.current_post_id;
  },
  [GETTER_ONE_USER_MEDIA](state: InsUserMediaList) {
    return (user_id: string) =>
      state.ins_user_media_list.find(
        (item: OneUserMediaInfoList) => item.user_id === user_id
      );
  }
};
export default Getters;
